import { createPortal } from 'react-dom';
import { HelpTip } from '@/components/HelpTip';

const tooltipPortals: NodeListOf<HTMLSpanElement> =
  document.querySelectorAll('[data-tooltip]');

export const useTooltips = () =>
  Array.from(tooltipPortals).map(portal => {
    const tip = portal.dataset.tooltip ?? '';

    return createPortal(
      <HelpTip
        key={tip}
        label="Helpful information"
        tip={tip}
        variant="info"
      />,
      portal,
    );
  });
